(function () {
  'use strict';

  document.querySelectorAll('.kc-bestsellers-section').forEach(function (section) {
    var tabs    = Array.from(section.querySelectorAll('[data-bs-tab]'));
    var panels  = Array.from(section.querySelectorAll('[data-bs-panel]'));
    var prevBtn = section.querySelector('[data-bs-prev]');
    var nextBtn = section.querySelector('[data-bs-next]');

    function activePanel() {
      return section.querySelector('.kc-bs__panel--active');
    }

    function activeTrack() {
      var p = activePanel();
      return p ? p.querySelector('[data-bs-track]') : null;
    }

    function cards(track) {
      return Array.from(track.querySelectorAll('product-item.kc-card'));
    }

    /* Kaydırma pozisyonuna göre en solda görünen kart indeksi */
    function visibleIndex(track) {
      var scrollLeft = track.scrollLeft;
      var list = cards(track);
      var best = 0;
      var bestDist = Infinity;
      list.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    /* Karta smooth scroll */
    function scrollTo(track, idx) {
      var list = cards(track);
      if (!list[idx]) return;
      track.scrollTo({ left: list[idx].offsetLeft, behavior: 'smooth' });
    }

    /* ---- DOTS ---- */

    function buildDots(panel) {
      var track   = panel.querySelector('[data-bs-track]');
      var dotWrap = panel.querySelector('[data-bs-dots]');
      if (!track || !dotWrap) return;

      var list = cards(track);
      dotWrap.innerHTML = '';
      list.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.className = 'kc-bs__dot' + (i === 0 ? ' kc-bs__dot--active' : '');
        btn.setAttribute('aria-label', String(i + 1) + '. ürün');
        btn.addEventListener('click', function () { scrollTo(track, i); });
        dotWrap.appendChild(btn);
      });
    }

    function syncDots(panel) {
      var track   = panel.querySelector('[data-bs-track]');
      var dotWrap = panel.querySelector('[data-bs-dots]');
      if (!track || !dotWrap) return;
      var idx  = visibleIndex(track);
      var dots = dotWrap.querySelectorAll('.kc-bs__dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('kc-bs__dot--active', i === idx);
      });
    }

    /* ---- OKLAR ---- */

    function syncArrows() {
      if (!prevBtn || !nextBtn) return;
      var track = activeTrack();
      if (!track) { prevBtn.disabled = true; nextBtn.disabled = true; return; }
      var idx   = visibleIndex(track);
      var total = cards(track).length;
      prevBtn.disabled = idx === 0;
      nextBtn.disabled = idx >= total - 1;
    }

    /* ---- TAB GEÇİŞİ ---- */

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = parseInt(tab.getAttribute('data-bs-tab'), 10);

        tabs.forEach(function (t) {
          t.classList.remove('kc-bs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('kc-bs__panel--active'); });

        tab.classList.add('kc-bs__tab--active');
        tab.setAttribute('aria-selected', 'true');

        var targetPanel = section.querySelector('[data-bs-panel="' + target + '"]');
        if (targetPanel) {
          targetPanel.classList.add('kc-bs__panel--active');
          var newTrack = targetPanel.querySelector('[data-bs-track]');
          if (newTrack) newTrack.scrollLeft = 0;
          syncArrows();
        }
      });
    });

    /* ---- OK TIKLAMA ---- */

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var track = activeTrack();
        if (!track) return;
        scrollTo(track, Math.max(0, visibleIndex(track) - 1));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var track = activeTrack();
        if (!track) return;
        var list = cards(track);
        scrollTo(track, Math.min(list.length - 1, visibleIndex(track) + 1));
      });
    }

    /* ---- SCROLL → SYNC ---- */

    panels.forEach(function (panel) {
      buildDots(panel);
      var track = panel.querySelector('[data-bs-track]');
      if (!track) return;
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          syncDots(panel);
          if (panel.classList.contains('kc-bs__panel--active')) syncArrows();
        }, 60);
      }, { passive: true });
    });

    syncArrows();
  });
}());
